import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { useSpring, animated } from 'react-spring';

function Number({ n }) {
    const { number } = useSpring({
        from: { number: 0 },
        number: n,
        delay: 200,
        config: { mass: 1, tension: 20, friction: 10 },
    });
    return <animated.div className="counter-numbers">{number.to((n) => n.toFixed(0))}</animated.div>;
}

function ProgressCounter() {
    const [isVisible, setIsVisible] = useState(false);
    const counterRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.unobserve(entry.target);
                }
            },
            {
                root: null,
                rootMargin: '0px',
                threshold: 0.5, // Change this threshold according to your need
            }
        );

        if (counterRef.current) {
            observer.observe(counterRef.current);
        }

        return () => {
            if (counterRef.current) {
                observer.unobserve(counterRef.current);
            }
        };
    }, []);

    return (
        <Wrapper ref={counterRef}>
            {isVisible && (
                <section className="progress-counter">
                    <div className="container">
                        <div className="parts-container">
                            <div className="parts">
                                <i className="fa-solid fa-child"></i>
                                <div style={{ display: 'flex' }}>
                                    <Number className="counter-numbers" n={250} />
                                    <h2 style={{ margin: 'auto' }}>+</h2>
                                </div>
                                <li>student</li>
                            </div>
                            <div className="parts">
                                <i className="fa-solid fa-chalkboard-user"></i>
                                <div style={{ display: 'flex' }}>
                                    <Number className="counter-numbers" n={21} />
                                    <h2 style={{ margin: 'auto' }}>+</h2>
                                </div>
                                <li>Teacher</li>
                            </div>
                            <div className="parts">
                                <i className="fa-solid fa-calendar-days"></i>
                                <div style={{ display: 'flex' }}>
                                    <Number className="counter-numbers" n={5} />
                                    <h2 style={{ margin: 'auto' }}>+</h2>
                                </div>
                                <li>Years Experience</li>
                            </div>
                            <div className="parts">
                                <i className="fa-solid fa-house-chimney-window"></i>
                                <div style={{ display: 'flex' }}>
                                    <Number className="counter-numbers" n={500} />
                                    <h2 style={{ margin: 'auto' }}>+</h2>
                                </div>
                                <li>Stisfied Parents</li>
                            </div>
                        </div>
                    </div>
                </section>
            )}
        </Wrapper>
    );
}
const Wrapper = styled.section`


* {
    padding: 0;
    margin: 0;
    color: white;
  }
  li{
    list-style: none;
  }
  .container {
    width: 100vw;
    margin: auto;
    padding-right: 15px;
    padding-left: 15px;
    justify-content: space-between;
  }
  
  
  .progress-counter{
    background: linear-gradient(45deg, #79c0f0, rgb(98 84 243));
    
  
  }
  .parts-container{
    display: grid;
    grid-template-columns: auto auto auto auto;
    padding: 3rem;
  }
  .parts{
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 2rem;
  }
  .counter-numbers{
    font-size: 5rem;
    margin: auto;
}

  .parts li{
    font-size: 2.5rem;
    }
  .parts i{
     font-size: 3rem;
  }
  .parts #counter-numbers{
    font-size: 5rem;
    padding: 0;
  }


  @media (max-width:998px) {
  }
  
  @media (max-width:768px) {
  .parts-container{
    grid-template-columns: auto auto;
    }
    .parts i{
        font-size: 3.5rem;
     }
    .parts li{
     font-size: 3rem;
    }
    
  }
  @media (max-width:425px) {
  .parts-container{
    grid-template-columns: auto;
  }
  .parts i{
    font-size: 3.9rem;
 }
 .parts li{
    font-size: 3.2rem;
    }

  }


`;

export default ProgressCounter;
